import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import TotWorkCard from '../components/total-work/TotWorkCard';
import axios from "axios";
import * as securityHelper from "../helper/SecurityHelper";

interface WorkList {
  evntName: string;
  evntEngName: string;
  totalWork: number;
  dangerWork: number;
};

// AUTH === 'KOX/COM/SRV' 접근 가능
export default function TotWork() {
  const navigate = useNavigate();
  const [workList, setWorkList] = useState<WorkList[]>();
  const user: any = securityHelper.getLoginUser();
  const [totWrkInfo, setTotWrkInfo] = useState<any>({});
  useEffect(() => {
    fn_retrieveTotWrkInfoData();
    // axios로 work data 가져오기
  }, []);

  const fn_retrieveTotWrkInfoData = async () => {
    let param = {};
    const auth = user.auth;
    if (auth === 'KOX') {
      param = { auth: auth };
    } else if (auth === 'COM') {
      param = { auth: auth, hstCmpnySeq: user.companySeq }
    } else if (auth === 'SRV') {
      param = { auth: auth, cmpnySeq: user.companySeq, date: new Date() }
    }

    const rtrnData = await axios.post('admin/api/dngrEval/retrieveTotWrkInfoData', param);
    setWorkList(rtrnData.data.evntListData);
    setTotWrkInfo(rtrnData.data.totWrkInfo);
  }

  return (
    <div className='w-screen h-[calc(100dvh)]'>
      <NavbarText backEvent={() => navigate(-1)}>총 작업</NavbarText>
      <div className='h-[calc(100%-52px)] md:h-[calc(100%-130px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center '>
        <div className='mb-20 md:mb-[50px] items-center px-15 md:px-[37px] w-[265px] sm:w-[318px] md:w-[750px]'>
          <p className='mt-30 md:mt-[75px] pl-15 md:pl-[37px] text-15 md:text-37 font-preBold'>금일 예정작업</p>
          <div className='w-[100%] h-75 md:h-[187px] rounded-[5px] md:rounded-[12px] bg-[#F6F7F9] flex items-center justify-center mt-15 md:mt-[37px] content-center '>
            <div className='flex flex-col justify-center'>
              <p className='text-14 md:text-35 font-preBold leading-[17px] md:leading-[42px]'>일반 작업</p>
              <p className='text-20 md:text-50 text-point font-preBold leading-[24px] md:leading-[60px] ml-50 sm:ml-60 md:ml-[150px]'>{totWrkInfo?.totWrkCnt - totWrkInfo?.dngrWrkCnt}
                <span className='text-txtBlack font-medium'>건</span></p>
            </div>
            <div className='border-[0.5px] border-y-0 border-l-0 h-59 md:h-[147px] border-[#CACACA] ml-10 sm:ml-13 md:ml-[32px] mr-12 sm:mr-20 md:mr-[50px] ' />
            <div className='flex flex-col justify-center'>
              <p className='text-14 md:text-35 font-preBold leading-[17px] md:leading-[42px]'>위험 작업</p>
              <p className='text-20 md:text-50 text-point font-preBold leading-[24px] md:leading-[60px] ml-50 sm:ml-60 md:ml-[150px]'>{totWrkInfo?.dngrWrkCnt}
                <span className='text-txtBlack font-medium'>건</span></p>
            </div>
          </div>
          <div>
            {workList?.map((item, idx) => {
              return (
                <TotWorkCard key={idx} work={item} />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

